/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';

import { Link, ModalCircledIcon, THEME_CONSTANTS } from '@cof/plastic-components';

import pushToDataLayer, { EVENTS } from '../../utilities/dataLayer';
import HiddenText from '../HiddenText';

const { FONT_WEIGHTS } = THEME_CONSTANTS;

const ModalLink = React.forwardRef(({ children, modalName, onClick, ...props }, ref) => {
    const handleClick = (event) => {
        if (event) {
            event.preventDefault();
        }
        if (modalName) {
            pushToDataLayer({
                event: EVENTS.MODAL_OPEN,
                modalName
            });
        }
        onClick(event);
    };
    return (
        <Link fontWeight={FONT_WEIGHTS.SB} href="#" ref={ref} onClick={handleClick} {...props}>
            {children}
            <HiddenText path="PopupWindow" />
            <ModalCircledIcon verticalAlign="bottom" ml="0.3rem" size={24} />
        </Link>
    );
});

ModalLink.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func.isRequired,
    modalName: PropTypes.string
};

ModalLink.displayName = 'ModalLink';

export default ModalLink;
